import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { getStorageOffersPageParamsSchema } from 'src/pages/storage/offers-new/overview/schema';

export function useStorageOffersPageParams() {
  return usePageParamsFromSchema(getStorageOffersPageParamsSchema(), {
    filters: {
      offerName: { label: 'Offer Name' },
      offerBusinessId: { label: 'Offer ID' },
      storageLocationId: { label: 'Storage Location' },
      ssoOrganisationId: { label: 'SSO' },
      typeOfProduct: { label: 'Product Type' },
      productRuntimeStart: { label: 'Runtime' },
      productRuntimeEnd: { label: 'Runtime' },
      offerStatus: { label: 'Status' },
      offersWithAllocations: {
        label: 'Offers With Allocations',
      },
    },
  });
}

export type StorageOffersPageParams = ReturnType<
  typeof useStorageOffersPageParams
>;
